<template>
  <el-container class="workspace-page slideshow-page">
    <el-header height="auto" class="workspace-toolbar">
      <el-row type="flex" justify="space-between" align="middle" style="margin: 10px 0;">
        <el-button type="primary" @click="openDialog()">{{ $t("新增轮播图") }}</el-button>
      </el-row>
      <el-dialog :title="dialog.form.id ? $t('编辑轮播图') : $t('新增轮播图')" :visible.sync="dialog.visible" width="30%">
        <el-form :model="dialog.form" label-width="auto">
          <el-form-item :label="$t('封面图')">
            <input
                id="slideshow-cover-input"
                ref="coverInput"
                class="cover-hidden-input"
                type="file"
                name="coverImage"
                accept="image/*"
                :disabled="dialog.uploading"
                @change="onCoverInputChange"
            />
            <label
                class="cover-uploader"
                :class="{ 'cover-uploader--disabled': dialog.uploading }"
                for="slideshow-cover-input"
                tabindex="0"
                role="button"
            >
              <template v-if="dialog.form.image">
                <img :src="dialog.form.image" :alt="$t('封面图预览')" class="cover-preview"/>
              </template>
              <template v-else>
                <div class="cover-upload-placeholder">
                  <i class="el-icon-plus cover-upload-icon"></i>
                  <div class="cover-upload-text">{{ $t("点击上传") }}</div>
                </div>
              </template>
              <div v-if="dialog.uploading" class="cover-upload-mask">
                <i class="el-icon-loading"></i>
              </div>
            </label>
            <div v-if="dialog.form.image" class="cover-tip">{{ $t("已上传封面图，可重新上传覆盖。") }}</div>
          </el-form-item>
          <el-form-item :label="$t('跳转链接')">
            <el-input v-model="dialog.form.article" :placeholder="$t('请输入跳转链接')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('排序')">
            <el-input v-model="dialog.form.sort" :placeholder="$t('请输入排序')"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button
              v-if="dialog.form.id"
              type="danger"
              @click="remove(dialog.form)">{{ $t("删除") }}</el-button>
          <el-button @click="dialog.visible=false">{{ $t("取消") }}</el-button>
          <el-button type="primary" @click="saveSlideshow">{{ $t("保存") }}</el-button>
        </span>
      </el-dialog>
    </el-header>
    <el-main class="workspace-content slideshow-cards">
      <div
          v-for="item in slideshows"
          :key="item.id"
          class="slideshow-card">
        <img
          class="slideshow-card-image"
          :src="item.image"
          alt="slide"
          @click="openDialog(item)"/>
      </div>
      <div v-if="!slideshows.length" class="slideshow-empty">{{ $t("暂无轮播图") }}</div>
    </el-main>
  </el-container>
</template>

<script>
import { t } from "@/i18n";
import axios from 'axios'
import app from '@/App'

export default {
  name: 'Slideshow',
  data() {
    return {
      user: {},
      slideshows: [],
      dialog: {
        visible: false,
        form: {
          id: null,
          image: '',
          article: '',
          sort: ''
        },
        uploading: false
      }
    }
  },
  created() {
    app.methods.getUser().then((res) => {
      this.user = res.data;
    })
    this.fetchSlideshows()
  },
  methods: {
    fetchSlideshows() {
      axios.get(app.url + '/slideshows').then((res) => {
        if (Array.isArray(res.data)) {
          this.slideshows = res.data;
        }
      })
    },
    openDialog(item) {
      if (item) {
        this.dialog.form = {...item}
      } else {
        this.dialog.form = {id: null, image: '', article: '', sort: ''}
      }
      this.dialog.uploading = false
      this.dialog.visible = true
    },
    saveSlideshow() {
      if (this.dialog.uploading) {
        this.$message.warning(t("封面图上传中，请稍后再试"))
        return
      }
      if (!this.dialog.form.image) {
        this.$message.warning(t("请先上传封面图"))
        return
      }
      const form = {image: this.dialog.form.image, article: this.dialog.form.article, sort: this.dialog.form.sort}
      let request
      if (this.dialog.form.id) {
        request = axios.put(app.url + `/slideshows/${this.dialog.form.id}`, form)
      } else {
        request = axios.post(app.url + '/slideshows', form)
      }
      request.then(() => {
        this.dialog.visible = false
        this.fetchSlideshows()
      })
    },
    remove(item) {
      axios.delete(app.url + `/slideshows/${item.id}`).then(() => {
        this.fetchSlideshows()
      })
    },
    beforeCoverUpload(file) {
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        this.$message.error(t("只能上传图片文件"))
      }
      const isLt20M = file.size / 1024 / 1024 < 20
      if (!isLt20M) {
        this.$message.error(t("图片大小不能超过 20MB"))
      }
      return isImage && isLt20M
    },
    resetCoverInput() {
      const input = this.$refs.coverInput
      if (input) {
        input.value = ''
      }
    },
    async onCoverInputChange(event) {
      if (this.dialog.uploading) {
        this.resetCoverInput()
        return
      }
      const input = event.target
      const file = input?.files?.[0]
      if (!file) {
        return
      }
      if (!this.beforeCoverUpload(file)) {
        this.resetCoverInput()
        return
      }
      await this.uploadCoverFile(file)
    },
    async uploadCoverFile(file) {
      this.dialog.uploading = true
      try {
        const imageUrl = await app.methods.uploadFile(file)
        this.dialog.form.image = imageUrl
        this.$message.success(t("封面图上传成功"))
      } catch (error) {
        this.$message.error(t("封面图上传失败，请重试"))
      } finally {
        this.dialog.uploading = false
        this.resetCoverInput()
      }
    }
  }
}
</script>

<style scoped>
.cover-hidden-input {
  position: absolute;
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  border: 0;
  padding: 0;
  margin: 0;
}

.cover-uploader {
  position: relative;
  width: 160px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-color: var(--border-color);
  border-radius: 10px;
  cursor: pointer;
  overflow: hidden;
}

.cover-uploader--disabled {
  pointer-events: none;
  opacity: 0.6;
}

.cover-uploader:hover {
  border-color: var(--primary-color);
}

.cover-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.cover-upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.cover-upload-icon {
  font-size: 28px;
  color: #8c939d;
}

.cover-upload-text {
  margin-top: 6px;
  font-size: 12px;
  color: #909399;
}

.cover-upload-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #409eff;
  font-size: 24px;
}

.cover-tip {
  margin-top: 8px;
  font-size: 12px;
  color: #909399;
}

.slideshow-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 18px;
}

.slideshow-card {
  overflow: hidden;
  border: 1px solid var(--border-light);
  border-radius: 14px;
  background: var(--surface-color);
  box-shadow: 0 4px 18px var(--shadow-color);
}

.slideshow-card-image {
  cursor: pointer;
  display: block;
  width: 100%;
  aspect-ratio: 16 / 9;
  height: auto;
  object-fit: cover;
  border: 0;
  border-radius: 0;
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.slideshow-card-image:hover {
  opacity: 0.94;
  transform: scale(1.01);
}

.slideshow-card-row {
  display: flex;
  justify-content: space-between;
  padding: 6px 0;
  font-size: 13px;
}

.slideshow-card-label {
  color: #909399;
}

.slideshow-card-value {
  color: #303133;
  margin-left: 8px;
  text-align: right;
  flex: 1;
}

.slideshow-card-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 6px;
}

.slideshow-empty {
  text-align: center;
  color: #909399;
  font-size: 13px;
  padding: 16px 0 8px;
}

@media (max-width: 768px) {
  .slideshow-cards {
    grid-template-columns: 1fr;
  }

  .slideshow-card-image:hover {
    transform: none;
  }
}
</style>
